import { toast as Toast } from 'react-toastify';
import { Toast as Template } from 'components-guide';

export const NOTIFICATION_TYPES = {
    default: 'default',
    dark: 'dark',
    info: 'info',
    success: 'success',
    error: 'error',
    warning: 'warning',
};

/**
 * More info
 * Doc: https://fkhadra.github.io/react-toastify/introduction/
 */
const OPTIONS = {
    autoClose: 5000,
    position: 'bottom-right',
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
};

const send = ({
    title = '',
    message = '',
    type,
    duration = OPTIONS.autoClose,
    ...otherOptions
}) => {
    const options = {
        ...OPTIONS,
        ...otherOptions,
        autoClose: duration,
    };
    Toast[type](() => Template({ title, message }), options);
};

const error = ({
    status,
    data,
    duration = OPTIONS.autoClose,
    ...otherOptions
}) => {
    const options = {
        ...OPTIONS,
        ...otherOptions,
        autoClose: duration,
    };
    Toast[NOTIFICATION_TYPES.error](() => Template(data), options);
};

const sendInfo = notification =>
    send({ type: NOTIFICATION_TYPES.info, ...notification });
const sendWarning = notification =>
    send({ type: NOTIFICATION_TYPES.warning, ...notification });
const sendError = notification =>
    send({ type: NOTIFICATION_TYPES.error, ...notification });
const sendSuccess = notification =>
    send({ type: NOTIFICATION_TYPES.success, ...notification });

export default {
    send,
    error,
    sendInfo,
    sendWarning,
    sendError,
    sendSuccess,
};
